import {
  FrontendModule,
  createFrontendModule,
} from '@backstage/frontend-plugin-api';
import { searchPageOverride } from './searchPageOverride';

// pluginId: 'search' namespaces the extension to the `search` plugin, so
// searchPageOverride (no `name`) resolves to id `page:search` — overriding
// the default page from @backstage/plugin-search/alpha.
export const searchModule: FrontendModule = createFrontendModule({
  pluginId: 'search',
  extensions: [searchPageOverride],
});
